import { DownloadSimple } from '@phosphor-icons/react';
import _ from 'lodash';
import { useEffect, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from '~/components/ui/button';
import { DialogClose } from '~/components/ui/dialog';
import { Input } from '~/components/ui/input';

interface LeftSectionProps {
  onTitleChange: (title: string) => void;
  onDownload: () => void;
  isDownloading: boolean;
  isGenerating: boolean;
}

const LeftSection = ({
  onTitleChange,
  onDownload,
  isDownloading,
  isGenerating,
}: LeftSectionProps) => {
  const intl = useIntl();
  const DEBOUNCE_DURATION_MS = 350;

  const changeTitle = useRef(
    _.debounce((title: string) => {
      onTitleChange(title);
    }, DEBOUNCE_DURATION_MS),
  ).current;

  const DownloadText = () => {
    if (isGenerating) {
      return <FormattedMessage defaultMessage='Generating...' />;
    }
    if (isDownloading) {
      return <FormattedMessage defaultMessage='Downloading...' />;
    }
    return <FormattedMessage defaultMessage='Download' />;
  };

  useEffect(() => {
    return () => {
      changeTitle.cancel();
    };
  }, [changeTitle]);

  return (
    <div className='flex flex-col justify-between h-full basis-96 border-r border-gray-200 px-7 pt-12 pb-24'>
      <div className='flex flex-col w-full gap-2'>
        <p className='text-base'>
          <FormattedMessage defaultMessage='Report Title' />
        </p>
        <Input
          placeholder={intl.formatMessage({
            defaultMessage: 'Add a title',
          })}
          size='lg'
          type='search'
          variant='soft'
          onChange={(e) => changeTitle(e.target.value)}
          id='report-title'
        />
      </div>
      <div className='flex flex-row justify-center gap-4'>
        <DialogClose asChild>
          <Button variant='plain' color='neutral'>
            <FormattedMessage defaultMessage='Cancel' />
          </Button>
        </DialogClose>
        <Button
          loading={isDownloading || isGenerating}
          disabled={isDownloading || isGenerating}
          onClick={onDownload}
          color='primary'
          size='lg'
          endDecorator={<DownloadSimple />}
        >
          <p className='text-sm font-semibold'>
            <DownloadText />
          </p>
        </Button>
      </div>
    </div>
  );
};

export default LeftSection;
